(function(angular, module) {var tagDirectve;

tagDirectve = function(tagClassFilter) {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'util/tags/tag',
    scope: {
      tag: '=',
      remove: '&'
    },
    link: function(scope, element) {
      element.addClass(tagClassFilter(scope.tag).join(' '));
    }
  };
};

module.directive('dybTag', tagDirectve);
})(angular, angular.module("dybTags"));